import * as React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Root from "./routes/root";
import ErrorPage from "./error-page";
import Hesaplar from "./views/Hesaplar"
import HesapDuzenle from "./views/HesapDuzenle"
import Giris from "./views/Giris"
import AuthenticationControl from "./AuthenticationControl";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthenticationControl><Root/></AuthenticationControl>,
    errorElement:<ErrorPage/>,
        children: [
      {
        index:true,
        element: <Hesaplar />,
      },
      {
        path: "settings/:accountId",
        element: <HesapDuzenle />,
      }
    ],
  },
  {
    path: "login",
    element: <Giris />,
  }
  
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);